<header class="site_header">
  <nav>
    <ul class="action_menu">
      @if(showNotificationButton()){
      <li>
        <p-button icon="pi pi-bell" label="Enable Notifications" (click)="enableNotifications()"
          class="p-button-text p-button-sm" [style]="{'margin-right': '10px'}"
          pTooltip="Enable push notifications to stay updated" tooltipPosition="bottom"></p-button>
      </li>
      }
      <!-- ── Global Search ── -->
      @if(showGlobalSearch()) {
      <li class="gs-nav-item">
        <quote-hub-global-search />
      </li>
      }

      <li (click)="getNotifications(this.limit())">
        <figure (click)="visible = true">
          <span class="pi pi-bell"></span>
          @if (unreadCount()) {
          <p-badge [value]="unreadCount()" />
          }
        </figure>
        <p-drawer [(visible)]="visible" position="right">
          <ng-template pTemplate="header">
            <div
              style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-right: 10px;">
              <h3 style="margin: 0;">Notifications</h3>
              @if (recievedNotifications() && recievedNotifications().length) {
              <p-button label="Mark as read" (click)="getNotifications(null,1)"></p-button>
              }
            </div>
          </ng-template>

          <div class="noti_menu">

            @if (recievedNotifications() && recievedNotifications().length) {

            <ul>
              @for (item of recievedNotifications(); track $index; let i = $index) {
              <li [ngClass]="item.is_read ? '' : 'active'"
                (click)="navigateDetail(item.redirection_key ? item.redirection_key : '', item)">
                <p>{{ item.message }}</p>
                <span>{{ item.created_at | date:'medium' }}</span>
              </li>
              }
            </ul>

            @if (recievedNotifications().length < totalCount()) { <div class="text_center">
              <p-button class="text_btn" variant="text" (click)="updateNotifications()">View all</p-button>
          </div>
          }

          } @else {
          <p>No Notification Found</p>
          }

          </div>
        </p-drawer>

      </li>

      <li>
        <!-- ✅ Profile avatar: shows image if available, else icon -->
        <figure (click)="userMenu.toggle($event)" class="user_avatar_figure">
          @if (profileImage()) {
          <img [src]="profileImage()" alt="Profile" class="user_avatar_img" />
          } @else {
          <span class="pi pi-user"></span>
          }
        </figure>

        <p-menu #userMenu [model]="items" [popup]="true" styleClass="user_menu" appendTo="body">
          <ng-template pTemplate="start">
            <p>
              <strong>{{ displayName() }}</strong>
              <span>{{ email() }}</span>
            </p>

            <p-button variant="outlined" [routerLink]="['/profile']">
              <i class="pi pi-user"></i>
              <span>Profile</span>
            </p-button>
            @if(userRole === 'ADMIN' || userRole === 'APPROVER'){
            <p-button variant="outlined" [routerLink]="['/settings']">
              <i class="pi pi-cog"></i>
              <span>General Settings</span>
            </p-button>
            }
            <p-button variant="outlined" (click)="logout()">
              <i class="pi pi-sign-out"></i>
              <span>Logout</span>
            </p-button>

          </ng-template>
        </p-menu>
      </li>
    </ul>
  </nav>
</header>